import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './Card.css';

export interface ICardProps {
  joinTop?: boolean;
  joinBottom?: boolean;
  className?: string;
  isFatGalleryEnabled?: boolean;
  dataName?: string;
}

export class Card extends React.Component<React.PropsWithChildren<ICardProps>> {
  public render() {
    const { children, className, joinTop, joinBottom, isFatGalleryEnabled, dataName } = this.props;

    return (
      <div
        {...mergeStyles(
          styles['container'],
          joinTop && styles['join-top'],
          joinBottom && styles['join-bottom'],
          isFatGalleryEnabled && styles['fat_gallery_cover'],
          className,
        )}
        data-name={dataName}
      >
        {children}
      </div>
    );
  }
}
